import SliderVerify from './src/slider-verify';

SliderVerify.install = function(Vue) {
	Vue.component(SliderVerify.name, SliderVerify);
};

export default SliderVerify;



// WEBPACK FOOTER //
// ./src/components/slider-verify/index.js